import * as types from '../actions/actionTypes';
import initialState from './initialState';
import moment from 'moment'


export default function contractInfoReducer(state = initialState.contractInfo, action) {
  switch (action.type) {
    case types.SET_CONTRACT_INFO:
      return Object.assign({}, state, action.contractInfo);
    case types.RESET_CONTRACT_INFO:
      return Object.assign({}, state,  initialState.contractInfo)
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/contractInfoReducer.js